var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "204.667px",
    height: "158.667px",
    viewBox: "0 0 204.667 158.667",
    enableBackground: "new 0 0 204.667 158.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.35,73.272c-9.243,0-16.735,7.493-16.735,16.736c0,9.244,7.493,16.736,16.735,16.736 c9.244,0,16.737-7.493,16.737-16.736C81.086,80.765,73.594,73.272,64.35,73.272z M71.874,86.408 c-2.938,1.188-4.813-3.063-1.875-4.438C73.187,80.908,74.812,85.22,71.874,86.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.537,73.272c-9.242,0-16.734,7.493-16.734,16.736c0,9.244,7.492,16.736,16.734,16.736 c9.244,0,16.737-7.493,16.737-16.736C157.274,80.765,149.781,73.272,140.537,73.272z M148.063,86.408 c-2.938,1.188-4.813-3.063-1.875-4.438C149.375,80.908,151,85.22,148.063,86.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005,103.97c-2.75-1.313-2.7,5.3-8,4c-2.545-0.122-3.878-1.456-4-4c0.26-4.74,6.901-3.099,6-9 c-0.842-2.18-4.586-3.256-8.502-3.406c-3.916,0.149-7.662,1.226-8.504,3.406c-0.901,5.901,5.74,4.26,6,9 c-0.122,2.544-1.455,3.878-4,4c-5.3,1.3-5.25-5.313-8-4c-5.416,2.268-0.221,10.817,7,11c2.411,0.061,4.897-2.595,7.504-2.842 c2.664,0.205,5.091,2.903,7.502,2.842C117.226,114.788,122.421,106.238,117.005,103.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.005,58.97c2.948-15.006,2.161-50.037-10-53c-10.556-2.572-27.656,15.033-36,21c-7.181-2.417-16.854-3.87-26.502-3.999 c-9.648,0.129-19.323,1.582-26.504,3.999c-8.344-5.967-25.444-23.572-36-21c-12.162,2.963-12.948,37.994-10,53 c-6.196,7.47-9.972,19.302-9.975,30.604c-0.003,14.176,5.538,23.926,5.538,23.926c6.44,12.226,18.563,21.75,29.437,27.47 c6.938,3.649,19.838,9.582,47.504,9.663c27.666-0.081,40.563-6.014,47.502-9.663c10.874-5.72,22.996-15.244,29.437-27.47 c0,0,5.541-9.75,5.538-23.926C184.977,78.272,181.201,66.44,175.005,58.97z M169.005,110.97c-2.397,4.748-13.385,15.401-23,20 c0,0-18.5,10-43.502,9.167c-25.002,0.833-43.504-9.167-43.504-9.167c-9.615-4.599-20.602-15.252-23-20s-5.749-8.845-5.998-21.471 c-0.227-11.503,4.334-22.526,9.998-30.529c-1.887-13.495-1.857-32.086,3-42c12.041,4.625,20.547,12.787,29,21 c2.536-1.291,5.347-2.223,7.875-2.719c0.594,2.156,1.64,17.721,8.125,18.042c9.25,0.458,3.453-20.06,4.078-20.122 c1.717-0.171,2.545-0.219,4.172-0.201c0.908,8.483,0.002,19.446,6.254,19.396c6.252,0.05,5.344-10.914,6.252-19.396 c1.627-0.018,2.455,0.03,4.172,0.201c0.625,0.063-5.172,20.58,4.078,20.122c6.485-0.321,7.531-15.886,8.125-18.042 c2.528,0.496,5.339,1.428,7.875,2.719c8.453-8.213,16.959-16.375,29-21c4.857,9.914,4.887,28.505,3,42 c5.664,8.003,10.226,19.026,9.998,30.529C174.754,102.125,171.402,106.222,169.005,110.97z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M43.5,93.5c0,0-9.833-1.833-35.167,1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M45.5,105.167c0,0-14.5,0.5-31.333,8.833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M161.504,93.5c0,0,9.833-1.833,35.166,1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M159.504,105.167c0,0,14.5,0.5,31.334,8.833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.2f54153ab33d35a2b05a4ade798ef1e1.svg";
export { ForwardRef as ReactComponent };